import { render } from "./SignIn.vue?vue&type=template&id=31f5d426&scoped=true"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=31f5d426&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Desktop/supaionic/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f5d426"]])